import type { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { Box, Button, Card, Typography } from '@packages/shared';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';

export const InspiringSearchMoreCardFragment = graphql(/* GraphQL */ `
  fragment InspiringSearchMoreCardFragment on SuggestionPreview {
    query
  }
`);

export type InspiringSearchMoreCardProps = {
  maskedSuggestion: FragmentType<typeof InspiringSearchMoreCardFragment>;
};

const messages = defineMessages({
  text: {
    id: 'search.inspiringSearch.previewPage.moreCard.text',
    defaultMessage: 'Entdecke alles in',
    description: 'Inspired search preview more card',
  },
  button: {
    id: 'search.inspiringSearch.previewPage.moreCard.button',
    defaultMessage: 'Zu {query}',
    description: 'Inspired search preview more card button',
  },
});

/**
 * A card leading to more results in the same search query suggestion, to continue the user journey after the initial preview.
 * */
export const InspiringSearchMoreCard: FC<InspiringSearchMoreCardProps> = ({ maskedSuggestion }) => {
  const { formatMessage } = useIntl();

  const { query } = getFragmentData(InspiringSearchMoreCardFragment, maskedSuggestion);

  return (
    <Card
      sx={{
        backgroundColor: 'grey.light',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        alignItems: 'center',
        padding: 3,
      }}
    >
      <Box>
        <Typography variant="body2" sx={{ textAlign: 'center' }}>
          {formatMessage(messages.text)}
        </Typography>
        <Typography variant="body2" sx={{ textAlign: 'center', fontWeight: 'bold' }}>
          „{query}“
        </Typography>
      </Box>
      <Button color="primary">{formatMessage(messages.button, { query })}</Button>
    </Card>
  );
};
